const map = require('lodash/fp/map');
const getPath = require('lodash/fp/path');
const mutableSet = require('lodash/set');
const isPlainObject = require('lodash/isPlainObject');

// TODO extract to common dbk-utils?
function serialize(data) {
  return JSON.stringify(data, null, 2);
}

function defaultParamsToPath(params) {
  if (!('*' in params)) {
    throw new Error(
      'fromObject() requires a wild-carded route with a `*` parameter, ' +
      'unless using a custom transform function.\n' +
      `Matching against \`${serialize(params[0] || params)}\``
    );
  }
  return params['*'];
}

function lookup(obj, paramsToPath) {
  return map(({ req, res }) =>
    res.value(getPath(paramsToPath(req.params), obj))
  );
}

function setPath(obj, paramsToPath) {
  return map(({ req, res }) => {
    mutableSet(obj, paramsToPath(req.params), req.value);
    return res.ok();
  });
}

/**
 * Create a route definition with get and set handlers that will get from
 * and set to a supplied object according to the requested sub-path.
 * Expected usage is with a wildcarded `match()` expression.
 * @param {Object} objectToSet - the target object
 * @param {function} [paramsToPathTransform] - an optional transform function
 * to extract target object path from each request's parameters. Defaults to
 * `(params) => params['*']`
 * @param {boolean} [getOnly=false] - create only a get handler
 * in the returned definition
 * @returns {Object} - the route definition
 * @example
 * const data = {
 *   name: 'Bob',
 *   address: {
 *     number: 4,
 *     street: 'High Street',
 *     postCode: 'SW1A 1AA',
 *   },
 * };
 * muster()
 *   .match('data.*', fromObject(data))
 *   .run();
 *
 * muster.get('data.name');
 * // => 'Bob'
 * muster.get('data.address.number');
 * // => 4
 * muster.set('data.smell', 'Odd');
 * muster.get('data.smell');
 * // => 'Odd'
 */
function fromObject(objectToSet, paramsToPathTransform = defaultParamsToPath, getOnly) {
  if (!objectToSet || !isPlainObject(objectToSet)) {
    const msg = 'fromObject(): Must supply an object to use in the graph, ' +
      `received \`${serialize(objectToSet)}\``;
    throw new Error(msg);
  }
  const routeDefinition = {
    get: lookup(objectToSet, paramsToPathTransform),
  };
  if (!getOnly) {
    routeDefinition.set = setPath(objectToSet, paramsToPathTransform);
  }
  return routeDefinition;
}

module.exports = fromObject;
